import React from "react";
import "../widgets.scss";
import "./image_view.scss";
import wrapWidget from "../WidgetHOC";
import wrapMockedWidget from "../MockedWidgetHOC";

import { Icon } from "react-icons-kit";
import { image } from "react-icons-kit/ionicons/";

const ImageView = props => {
  let { thisWidgetConfig, isMock } = props;

  // Image URL for now
  let { widgetSettings = {} } = thisWidgetConfig;
  let { image_url = "", image_layout = "0" } = widgetSettings;

  let layoutCSSClass = "";
  switch (image_layout) {
    case "0":
      layoutCSSClass += "fit-scale-down";
      break;
    case "1":
      layoutCSSClass += "fit-contain";
      break;
    case "2":
      layoutCSSClass += "fit-cover";
      break;
    default:
      break;
  }

  if (image_url === "" || isMock) {
    return (
      <div className="imageview_widget-mock">
        <Icon size={64} icon={image} />
      </div>
    );
  }

  return (
    <div className="imageview_widget">
      <img className={layoutCSSClass} src={image_url} alt={image_url}/>
    </div>
  );
};

const MockedImageView = wrapMockedWidget(ImageView);
export { MockedImageView };
export default wrapWidget(ImageView);
